<template>
  <div class="funds-management-settings">
    <p>Adjust funds release condition &amp; profit allocation</p>

    <b-row class="mt-4">
      <b-col cols="12" md="6" lg="4">
        <div class="card-table-simple">
          <b-table-simple responsive bordered>
            <b-thead>
              <b-tr>
                <b-th>#</b-th>
                <b-th>Fund Name</b-th>
                <b-th>Release Condition</b-th>
                <b-th>Profit (%)</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(setting, index) in fundsMgmtSettings" :key="index">
                <b-td class="text-center">{{ index + 1 }}</b-td>
                <b-td>{{ setting.fund_name }}</b-td>
                <b-td>
                  <div class="d-flex justify-content-between">
                    {{ setting.release_cond }}
                    <el-dropdown trigger="click" style="cursor: pointer">
                      <p class="el-dropdown-link mb-0 top-line">
                        <b-icon icon="chevron-down"></b-icon>
                      </p>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>Half Yearly</el-dropdown-item>
                        <el-dropdown-item>Monthly</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </b-td>
                <b-td>

                  <div class="d-flex justify-content-between">
                    {{ setting.profit }}
                    <el-dropdown trigger="click" style="cursor: pointer">
                      <p class="el-dropdown-link mb-0 top-line">
                        <b-icon icon="chevron-down"></b-icon>
                      </p>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>15</el-dropdown-item>
                        <el-dropdown-item>12</el-dropdown-item>
                        <el-dropdown-item>7.5</el-dropdown-item>
                        <el-dropdown-item>6</el-dropdown-item>
                        <el-dropdown-item>5</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="6" lg="4">
        <p class="mb-3">Adjust minimum investment amount per lot.</p>
        <div class="d-flex justify-content-between">
          <span>Minimum Amount (RM)</span>
          <span class="text-muted">Max. amount = RM500,000</span>
        </div>
        <CurrencyInput v-model="min_amt"
          :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
      </b-col>
    </b-row>
    <b-row class="my-5">
      <b-col cols="8" md="6" lg="4">
        <el-button type="primary">Save</el-button>
        <el-button type="primary" plain>Reset to default</el-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { Select, Option, DropdownMenu, DropdownItem, Dropdown, Button } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'

export default {
  components: {
    CurrencyInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
  },
  data() {
    return {
      activeName: '1',
      min_amt: 10000,
      fundsMgmtSettings: [
        {
          fund_name: 'JV Fund 1.0-15%',
          release_cond: 'Half Yearly',
          profit: 15
        }
      ],
    }
  },
}
</script>